






import Component from 'vue-class-component';
import Vue from 'vue';
import { Prop } from 'vue-property-decorator';

import Dialog from '@/store/modules/dialog';
import store from '@/store/store';
import { getModule } from 'vuex-module-decorators';
const dialogModule = getModule(Dialog, store);

@Component
export default class LikeCount extends Vue {
  @Prop(Number) fontSize: number;
  @Prop(Object) likers: { [uid: string]: boolean };

  get style() {
    return `font-size: ${this.fontSize || 30} px;`;
  }

  get likerUids(): string[] {
    const uids = [];
    Object.keys(this.likers).forEach((uid) => {
      if (this.likers[uid]) uids.push(uid);
    });
    return uids;
  }

  get likeCount() {
    return this.likerUids.length;
  }

  display() {
    dialogModule.openLikersDialog({ open: true, likerUids: this.likerUids });
  }
}
